import { Card, CardContent, FormControl, FormControlLabel, FormLabel, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { object, string } from "yup";
const FocusList = [
    "nome",
    "cognome",
    "sesso",
    "statocivile",
    "cap",
    "gg",
    "mm",
    "aaaa",
    "cellulare",
    "email",
    "colorepref",
    "tagliaAbituale"
];
const customerSchema = object({
    nome: string().required().min(3),
    cognome: string().required().min(3),
    sesso: string().required().min(1),
    statocivile: string().required().min(1),
    cap: string().required().min(5),
    gg: string().required().min(2),
    mm: string().required().min(2),
    aaaa: string().required().min(4),
    cellulare: string().required().min(4),
    email: string().required().min(5),
    colorepref: string().required().min(1),
    tagliaAbituale: string().required().min(1),
});

let timerKey = [];
const clearTM = () => {
    if (timerKey && timerKey.length) {
        timerKey.map((tm) => {
            return clearTimeout(tm);
        })
    }
};
const CustomerForm = ({ data = {}, touch = {}, validation = {}, onChange = () => { }, onBlur = () => { }, cfg = {}, colorList = [] }) => {
    const [fieldscustomerphysicalperson, setRequiredFields] = useState({});
    const [show_taglia_abitiale, setShowTagliaAbituale] = useState(false);
    const [show_colore_preferito, setShowColorePreferito] = useState(false);
    const onKeyDowm = (e) => {
        clearTM();

    }
    const onIntKeyDown = (e) => {
        clearTM();
        const isNum = [96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 49, 50, 51, 52, 53, 54, 55, 56, 57, 48].indexOf(e.keyCode) !== -1;
        const validKey = [8, 9, 37, 39, 46].indexOf(e.keyCode) !== -1;
        if (!isNum && !validKey) {
            if (e.preventDefault) e.preventDefault();
            e.stopPropagation();
        }
        return isNum || validKey;
    }
    const onKeyUp = (e) => {
        const special = [8, 9, 37, 39, 46].indexOf(e.keyCode) !== -1;
        if (special) return;
        const name = e.target.name;
        const value = e.target.value;
        if (name && value && customerSchema.fields[name]) {
            const schema = customerSchema.fields[name];
            try {
                schema.validateSync(value);
                /*
                timerKey.push(setTimeout(() => {
                    const focusPos = FocusList.indexOf(name);
                    if (focusPos !== -1 && FocusList[focusPos + 1]) {
                        const next = FocusList[focusPos + 1];
                        const el = document.getElementById(next);
                        if (el && el.focus) {
                            el.focus();
                        }
                    }
                }, 1000));
                */
            } catch (err) {

            }
        }
    }
    const onKeyUpWtm = (e) => {
        const special = [8, 9, 37, 39, 46].indexOf(e.keyCode) !== -1;
        if (special) return;
        const name = e.target.name;
        const value = e.target.value;
        if (name && value && customerSchema.fields[name]) {
            const schema = customerSchema.fields[name];
            try {
                schema.validateSync(value);
                const focusPos = FocusList.indexOf(name);
                if (focusPos !== -1 && FocusList[focusPos + 1]) {
                    const next = FocusList[focusPos + 1];
                    const el = document.getElementById(next);
                    if (el && el.focus) {
                        el.focus();
                    }
                }
            } catch (err) {

            }
        }
    }
    const isRequired = useCallback((field) => {
        if (fieldscustomerphysicalperson && fieldscustomerphysicalperson && typeof fieldscustomerphysicalperson[field] === "object" && fieldscustomerphysicalperson[field].mandatory) {
            return true;
        } else {
            return false;
        }
    }, [fieldscustomerphysicalperson]);

    useEffect(() => {
        const el = document.getElementById("nome");
        if (el && el.focus) {
            el.focus();
        }
        const fieldscustomerphysicalperson = Object.assign({
            nome: { mandatory: true },
            cognome: { mandatory: true },
            cellulare: { mandatory: true },
            dataDiNascita: { mandatory: true }

        }, JSON.parse(cfg.env.properties.fieldscustomerphysicalperson) || {});
        setRequiredFields(fieldscustomerphysicalperson);
        const { global = {} } = window.global;
        const { show_taglia_abituale, show_colore_preferito } = global || {};
        setShowTagliaAbituale(show_taglia_abituale || false);
        setShowColorePreferito(show_colore_preferito || false);
    }, [cfg])
    return <div className="customer-form">
        <Card style={{ flexGrow: 1, overflowY: 'auto' }} >
            <CardContent >
                <TextField
                    {...(touch.nome && validation.nome ? { error: true } : {})}
                    {...(touch.nome && validation.nome ? { helperText: validation.nome, ...(isRequired("nome") ? { required: true } : {}) } : {})}
                    value={data.nome || ""} inputProps={{ id: "nome", style: { textTransform: 'uppercase' } }} label="NOME" variant="outlined" style={{ width: '100%', marginBottom: '0.5rem' }} name="nome" onChange={onChange} onKeyUp={onKeyUp} onKeyDown={onKeyDowm} onBlur={onBlur} />
                <TextField
                    {...(touch.cognome && validation.cognome ? { error: true } : {})}
                    {...(touch.cognome && validation.cognome ? { helperText: validation.cognome, ...(isRequired("cognome") ? { required: true } : {}) } : {})}
                    value={data.cognome || ""} inputProps={{ id: "cognome", style: { textTransform: 'uppercase' } }} label="COGNOME" variant="outlined" style={{ width: '100%', marginBottom: '0.5rem' }} name="cognome" onChange={onChange} onKeyUp={onKeyUp} onKeyDown={onKeyDowm} onBlur={onBlur} />
                <div className="radios" style={{ marginBottom: '0.5rem' }}>
                    <RadioGroup name="sesso" onChange={onChange} onKeyUp={onKeyUp} onKeyDown={onKeyDowm} value={data.sesso || ""}>
                        <FormLabel >Sesso</FormLabel>
                        <FormControlLabel value="M" control={<Radio id="sesso" />} label="Maschio" onBlur={onBlur} />
                        <FormControlLabel value="F" control={<Radio />} label="Femmina" onBlur={onBlur} />
                    </RadioGroup>
                    <RadioGroup name="statocivile" onChange={onChange} onKeyUp={onKeyUp} value={data.statocivile || ""} >
                        <FormLabel >Stato civile</FormLabel>
                        <FormControlLabel value="S" control={<Radio id="statocivile" />} label="Single" onBlur={onBlur} />
                        <FormControlLabel value="C" control={<Radio />} label="Coniugato" onBlur={onBlur} />
                    </RadioGroup>
                </div>
                <div>
                    <TextField
                        {...(touch.cap && validation.cap ? { error: true } : {})}
                        {...(touch.cap && validation.cap ? { helperText: validation.cap, ...(isRequired("cap") ? { required: true } : {}) } : {})}
                        value={data.cap || ""}
                        inputProps={{ maxLength: 5, id: "CAP", type: "number", pattern: "[0-9]*", inputMode: "numeric" }} label="CAP" name="cap" variant="outlined" style={{ width: '100%', marginBottom: '0.5rem' }} onChange={onChange} onKeyDown={onIntKeyDown} onKeyUp={onKeyUpWtm} onBlur={onBlur} />
                </div>
                <div style={{ marginBottom: '5px' }}>
                    <FormLabel>Data di nascita</FormLabel>
                </div>
                <div className="data-nascita" >
                    <TextField value={data.gg || ""} inputProps={{ maxLength: 2, id: "gg", type: "number", pattern: "[0-9]*", inputMode: "numeric" }} name="gg" label="giorno" variant="outlined" style={{ marginRight: '0.5rem' }} onChange={onChange} onKeyDown={onIntKeyDown} onKeyUp={onKeyUpWtm} onBlur={onBlur} />
                    <TextField value={data.mm || ""} inputProps={{ maxLength: 2, id: "mm", type: "number", pattern: "[0-9]*", inputMode: "numeric" }} name="mm" label="mese" variant="outlined" style={{ marginRight: '0.5rem' }} onChange={onChange} onKeyDown={onIntKeyDown} onKeyUp={onKeyUpWtm} onBlur={onBlur} />
                    <TextField value={data.aaaa || ""} inputProps={{ maxLength: 4, id: "aaaa", type: "number", pattern: "[0-9]*", inputMode: "numeric" }} name="aaaa" label="anno" variant="outlined" onChange={onChange} onKeyDown={onIntKeyDown} onKeyUp={onKeyUpWtm} onBlur={onBlur} />
                </div>
                <div style={{ marginBottom: '0.5rem' }}>
                    {(touch.gg || touch.mm || touch.aaaa) && validation.dataDiNascita &&
                        <FormLabel error={true} sx={{ fontSize: '0.8rem' }} >{validation.dataDiNascita}</FormLabel >
                    }
                </div>
                <TextField
                    {...(touch.cellulare && validation.cellulare ? { error: true } : {})}
                    {...(touch.cellulare && validation.cellulare ? { helperText: validation.cellulare, ...(isRequired("cellulare") ? { required: true } : {}) } : {})}
                    value={data.cellulare || ""} inputProps={{ maxLength: 13, id: "cellulare", type: "number", pattern: "[0-9]*", inputMode: "numeric" }} name="cellulare" label="CELLULARE" variant="outlined" style={{ width: '100%', marginBottom: '0.5rem' }} onChange={onChange} onKeyDown={onIntKeyDown} onKeyUp={onKeyUp} onBlur={onBlur} />
                <TextField
                    {...(touch.email && validation.email ? { error: true } : {})}
                    {...(touch.email && validation.email ? { helperText: validation.email, ...(isRequired("email") ? { required: true } : {}) } : {})}
                    value={data.email || ""} inputProps={{ id: "email" }} name="email" label="EMAIL" variant="outlined" style={{ width: '100%', marginBottom: '0.5rem' }} onChange={onChange} onKeyUp={onKeyUp} onKeyDown={onKeyDowm} onBlur={onBlur} />

                {show_colore_preferito && <FormControl style={{ width: '100%', marginBottom: '0.5rem' }}>
                    <InputLabel id="colore-preferito-select">COLORE PREFERITO</InputLabel>
                    <Select
                        id="colorepref"
                        label="COLORE PREFERITO"
                        name="colorepref"
                        onChange={onChange}
                        labelId="colore-preferito-select"
                        onKeyDown={onKeyDowm}
                        onBlur={onBlur}
                        value={data.colorepref || ""}
                        {...(touch.colorepref && validation.colorepref ? { error: true } : {})}
                    >
                        <MenuItem value={""}>NESSUNO</MenuItem>
                        {
                            (colorList || []).map((c, idx) => {
                                return <MenuItem key={`color_${idx}`} value={c.codice}>{c.descrizione}</MenuItem>
                            })
                        }

                    </Select>
                </FormControl>
                }
                {show_taglia_abitiale && <TextField
                    {...(touch.tagliaAbituale && validation.tagliaAbituale ? { error: true } : {})}
                    {...(touch.tagliaAbituale && validation.tagliaAbituale ? { helperText: validation.tagliaAbituale, ...(isRequired("tagliaAbituale") ? { required: true } : {}) } : {})}
                    value={data.tagliaAbituale || ""} inputProps={{ id: "tagliaAbituale", style: { textTransform: 'uppercase' } }} name="tagliaAbituale" label="TAGLIA ABITUALE" variant="outlined" style={{ width: '100%', marginBottom: '0.5rem' }} onChange={onChange} onKeyUp={onKeyUp} onKeyDown={onKeyDowm} onBlur={onBlur} />}

            </CardContent>

        </Card>
    </div>

}
export default CustomerForm;